import { useEffect } from "react";
import { Gift } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

const KEY = "snaplist.ref";

export function captureRefFromUrl() {
  const url = new URL(window.location.href);
  const code = (url.searchParams.get("ref") || "").trim().toUpperCase();
  if (!code) return;
  if (/^[A-Z0-9]{4,16}$/.test(code)) localStorage.setItem(KEY, code);
  url.searchParams.delete("ref");
  window.history.replaceState(null, "", url.pathname + url.search + url.hash);
}

export const inviteLink = (code) => `${window.location.origin}/?ref=${code}`;

const SRC_KEY = "snaplist.src";
// First visit only: where this browser came from (search, social, ad link), sent with the first sign-in.
export function captureSource() {
  if (localStorage.getItem(SRC_KEY)) return;
  const url = new URL(window.location.href);
  let referrer = "";
  try { referrer = document.referrer && new URL(document.referrer).host !== window.location.host ? document.referrer.slice(0, 300) : ""; } catch { /* bad referrer */ }
  const u = (k) => (url.searchParams.get(k) || "").slice(0, 80);
  localStorage.setItem(SRC_KEY, JSON.stringify({ referrer, utm_source: u("utm_source"), utm_medium: u("utm_medium"), utm_campaign: u("utm_campaign"), landing: url.pathname.slice(0, 200) }));
}
export function signupSource() {
  let s = {};
  try { s = JSON.parse(localStorage.getItem(SRC_KEY) || "{}"); } catch { /* corrupted */ }
  return { ...s, ref_code: localStorage.getItem(KEY) || "" };
}

export function ReferralClaimer() {
  useEffect(() => {
    const code = localStorage.getItem(KEY);
    if (!code) return;
    api.post("/referrals/claim", { code })
      .then(() => toast.success("Invite applied! After your first payment you both get 1 free month on Pro or Annual, or 2 free weeks on Starter.", { duration: 6000 }))
      .catch((e) => { if (e?.response?.status === 404 || e?.response?.status === 400) toast.error(e.response.data?.detail); })
      .finally(() => localStorage.removeItem(KEY));
  }, []);
  return null;
}

export function InviteBanner() {
  if (!localStorage.getItem(KEY)) return null;
  return (
    <div className="flex items-start gap-2 rounded-lg border border-emerald-200 bg-emerald-50 p-3 text-xs text-emerald-900" data-testid="login-invite-banner">
      <Gift className="mt-0.5 h-4 w-4 shrink-0 text-emerald-600" />
      <span>You've been invited! After your first payment, you <b>and</b> your friend each get a month free.</span>
    </div>
  );
}
